import type { KeySearchHit } from '@greco-gls/shared';

import { scopePath } from '@/api/endpoints';

/** The two characters the API asks for before it searches (§7.5A). */
export const MIN_SEARCH_LENGTH = 2;

/** Typing pauses this long before a search goes out — one request per pause, not per keystroke. */
export const SEARCH_DEBOUNCE_MS = 500;

/**
 * Where a hit opens: the keys list of its owner, filtered to the key and with its drawer open.
 *
 * A key of a project the caller cannot read reached them through a link (ADR 0006); it opens in the
 * linking project (`linkedVia`), whose list includes linked keys and whose key detail answers for
 * them — the owner's screens would refuse the caller.
 */
export function keySearchHitPath(hit: KeySearchHit): string {
  const scope = hit.linkedVia
    ? scopePath('project', hit.linkedVia)
    : scopePath(hit.ownerType, hit.ownerCode);
  const params = new URLSearchParams({ q: hit.name, key: String(hit.keyId) });
  return `${scope}/keys?${params.toString()}`;
}

/** The search page with the query (and nothing else) filled in. */
export function keySearchPagePath(query: string): string {
  return `/search?${new URLSearchParams({ q: query }).toString()}`;
}
